import shortlistedEnquiry from './shortlist';
import transaction from './transaction';
import vehicle from './vehicle';

export default {
	shortlistedEnquiry,
	transaction,
	vehicle,
};
